import React, { useState, useEffect, useRef } from "react";
import { Button, Pagination, Tooltip, Whisper } from "rsuite";
import "./opportunity.scss";
import { numberFormatter } from "../../utils";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import moment from "moment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CSVLink } from "react-csv";

const ValueTrackerTable = (props: any) => {
	const handleRowClick = (supplierName: string) => {
		if (props.selectedSupplier === supplierName) {
			props.updateSelectedSupplier(null); // Deselect if already selected
		} else {
			props.updateSelectedSupplier(supplierName); // Select clicked row
		}
	};
	return (
		<table className="common-table-ui nia-negotiations-lhs-table h-[90%]">
			<thead>
				<tr>
					<th>Supplier</th>
					<th>{new Date().getFullYear() - 1} Spend/Sales</th>
					<th>{new Date().getFullYear() - 1} Rebate</th>
					<th>{new Date().getFullYear()} F Spend/Sales</th>
					<th>{new Date().getFullYear()} F Rebate</th>
					<th>
						{new Date().getFullYear()} YTD Rebate
						<Whisper
							placement="top"
							speaker={
								<Tooltip className="tooltipconfig">
									<div>
										Accruals till{" "}
										{moment(
											new Date(
												`${
													props?.data[0]?.refreshDate.split(
														"/"
													)[1]
												}/${
													props?.data[0]?.refreshDate.split(
														"/"
													)[0]
												}/${
													props?.data[0]?.refreshDate.split(
														"/"
													)[2]
												}`
											)
										).format("MM/DD/YYYY")}
									</div>
								</Tooltip>
							}
						>
							<InfoOutlineIcon className="ml-[.5vh]" />
						</Whisper>
					</th>
					<th>Incremental Rebate</th>
				</tr>
			</thead>
			<tbody>
				{props.data?.map((d: any, index: any) => {
					return (
						<tr
							key={index}
							onClick={() => {
								handleRowClick(d.Master_Vendor_Name);
							}}
							className={
								props.selectedSupplier === d.Master_Vendor_Name
									? "selected-row"
									: ""
							}
						>
							<td>{d.Master_Vendor_Name}</td>
							<td>{numberFormatter(d.lastYearCost, 2, "$")}</td>
							<td>{numberFormatter(d.last_rebate, 2, "$")}</td>
							<td style={{ width: "6vw" }}>
								<span
									style={{
										display: "inline-flex",
										alignItems: "center",
									}}
								>
									{numberFormatter(
										d.currentCost +
											d.consolidatedcost_Approach,
										2,
										"$"
									)}
									{d.consolidatedcost_Approach > 0 && (
										<Whisper
											placement="top"
											speaker={
												<Tooltip className="tooltipconfig">
													<div>
														2025 Graybar Spend :{" "}
														{numberFormatter(
															d.currentCost,
															2,
															"$"
														)}
													</div>
													<div>
														2025 Subsidies Spend :{" "}
														{numberFormatter(
															d.consolidatedcost_Approach,
															2,
															"$"
														)}
													</div>
												</Tooltip>
											}
										>
											<InfoOutlineIcon className="ml-[.5vh] mb-[.5vh]" />
										</Whisper>
									)}
								</span>
							</td>
							<td>{numberFormatter(d.cur_rebate, 2, "$")}</td>
							<td>
								{numberFormatter(
									d.Current_Year_YTD_Rebate,
									2,
									"$"
								)}
							</td>
							<td>
								{numberFormatter(
									d.cur_rebate - d.last_rebate,
									2,
									"$"
								)}
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};
export default ValueTrackerTable;
